import { AppAttribute } from "@interfaces/Internal/AppAttribute";
import { Button, ButtonProps } from "@material-ui/core";
import { PhotoLibrary } from "@material-ui/icons";
import React, { useState } from "react";
import { useStoreon } from "storeon/react";
import { EntityEvents, EntityState } from "@store/entity-module";
import { toFileId } from "@modules/Utils";
import { resolveFilePickerAnchor } from "@modules/FilePickerAnchor";
import FilePickerDialog from "@components/Controls/FilePicker/FilePickerDialog";

interface Props {
    attribute: AppAttribute;
}

/**
 * "Добавить из хранилища" — групповое добавление сразу нескольких файлов в
 * множественный атрибут (Файл/Изображение). Намеренно НЕ дублирует загрузку
 * с компьютера — для неё уже есть экран "Файловое хранилище" (там же создание
 * папок), менеджер сначала загружает файлы туда, а здесь только выбирает уже
 * загруженные. Это отдельный режим от "Выбрать файл" у конкретной строки
 * (UFileAutocomplete) — тот заменяет значение ОДНОЙ строки, этот создаёт
 * сразу несколько новых.
 */
const AddFilesFromStorageButton = ({ attribute, ...props }: Props & ButtonProps) => {
    const { attrs, dispatch } = useStoreon<EntityState, EntityEvents>("attrs");
    const [open, setOpen] = useState(false);

    const excludeFileIds = attribute.items
        .map((el) => toFileId(el.value))
        .filter((v): v is number => v !== null);

    const { anchorFileId, initialSearchTerm } = resolveFilePickerAnchor(attrs, excludeFileIds);

    const handleSelectMultiple = (fileIds: number[]) => {
        dispatch("entity/attr/add/values", {
            at_id: attribute.atype_id,
            values: fileIds,
        });
    };

    return (
        <>
            <Button {...props} onClick={() => setOpen(true)} startIcon={<PhotoLibrary />}>
                Добавить из хранилища
            </Button>
            <FilePickerDialog
                open={open}
                value={anchorFileId}
                initialSearchTerm={initialSearchTerm}
                multiple
                excludeFileIds={excludeFileIds}
                onSelectMultiple={handleSelectMultiple}
                onClose={() => setOpen(false)}
            />
        </>
    );
};

export default AddFilesFromStorageButton;
